import Constants from '../models/constants/Constants.js';

export default class ConfigurationController {
  constructor(resource) {
    this._resource = resource;
  }

  // Método não utilizado, foi substituído pelo this.getAll()
  // getAllConfigurationByClientId(clientId) {
  //   return this._resource(`configuration/${clientId}`)
  //     .get()
  //     .then(res => res.json())
  //     .catch(error => console.log(error));
  // }

  async update(configuration, client_id) {
    return this._resource(`configuration/${client_id}`)
      .update(configuration)
      .then(res => res.json());
  }

  async getAll(client_id) {
    try {
      let response = await this._resource(`configuration/`).get();

      // Substituição dos termos de uso
      // Cada cliente agora possui o seu respectivo termo de uso
      let clientTerms = await this._resource(
        `frotas-configuration/by-client/${client_id}`
      ).get();
      response.body.vehicle_schedule = clientTerms.body.vehicle_schedule
      let url_bucket = Constants.URL_BUCKET_PICKNDRIVE;
      response.body.term_of_use.value =
        url_bucket + clientTerms.body.terms_of_use;

      return response.body;
    } catch (error) {
      console.log(error);
    }
  }

  async getConfigMaps() {
    try {
      let response = await this._resource(`configurations/map`).get();
      return response.json();
    } catch (error) {
      console.log(error);
    }
  }

  async getAllFrotasConfiguration(client_id) {
    try {
      let response = await this._resource(
        `frotas-configuration/by-client/${client_id}`
      ).get();
      return response.body;
    } catch (error) {
      console.log(error);
    }
  }


}
